<template>

	<!-- Platform Settings Card -->
	<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0, paddingBottom: 0 }">
		<template #title>
			<h6 class="font-semibold m-0">平台设置</h6>
		</template>
		<ul class="list settings-list">
			<li>
				<h6 class="list-header text-sm text-muted">账号</h6>
			</li>
			<li>
				<a-switch v-model="emailForFollows" />
				<span>店铺出首单时邮箱通知我</span></span>
			</li>
			<li>
				<a-switch v-model="emailForAnswers"/>
				<span>新建店铺时邮箱通知我</span>
			</li>
			<li>
				<a-switch v-model="emailForMentions" />
				<span>接收系统通知</span>
			</li>
			<li>
				<h6 class="list-header text-sm text-muted m-0">应用</h6>
			</li>
			<li>
				<a-switch v-model="emailForNewProjects" />
				<span>爆品通知</span></span>
			</li>
			<li>
				<a-switch v-model="emailForProductUpdates" />
				<span>月度销售报表通知</span>
			</li>
		</ul>
	</a-card>
	<!-- / Platform Settings Card -->

</template>

<script>

	export default ({
		data() {
			return {
				// Binded model property for "Platform Settings" switch button for "Email ... follows me" .
				emailForFollows: true,

				// Binded model property for "Platform Settings" switch button for "Email ... answers me" .
				emailForAnswers: false,

				// Binded model property for "Platform Settings" switch button for "Email ... mentions me" .
				emailForMentions: true,

				// Binded model property for "Platform Settings" switch button for "New launches and projects" .
				emailForNewProjects: true,

				// Binded model property for "Platform Settings" switch button for "Monthly product updates" .
				emailForProductUpdates: false,

				// Binded model property for "Platform Settings" switch button for "Subscribe to newsletter" .
				emailForNewsletter: true,
			}
		},
	})

</script>